import React, { useEffect, useState } from 'react'
import { Typography, Paper, Avatar, Button, IconButton, InputAdornment } from '@material-ui/core'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import withStyles from '@material-ui/core/styles/withStyles'
import { Link, withRouter } from 'react-router-dom'
import firebase from '../firebase'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import InputLabel from '@material-ui/core/InputLabel'

const styles = theme => ({
	main: {
		height: '100vh',
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'top center',
		[theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
			backgroundPosition: 'center center',
		},
	},
	content: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'center',
		[theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
			alignItems: 'flex-end',
			justifyContent: 'center',
		},
	},
	paper: {
		display: 'flex',
		flexDirection: 'column',
		width: '94%',
		margin: 'auto',
		alignItems: 'center',
		zIndex: 99999,
		padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
		[theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
			width: 400,
		},
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '100%',
		marginTop: theme.spacing(1),
	},
	submit: {
		padding: 12,
		marginTop: theme.spacing(3)
	},
})

function Register(props) {
	const { classes } = props
	const { t } = useTranslation()
	const [name, setName] = useState('')
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [repeatpassword, setRepeatpassword] = useState('')
	const [values, setValues] = React.useState({
		showPassword: false,
		showPassword2: false,
	})

	useEffect(() => {
		document.title = window.localStorage.getItem('apptitle') + ` - ${t('registeraccount.label')}`
	}, [t])

	useEffect(() => {
		if (firebase.getCurrentUsername()) {
			window.location.href = '/dashboard'
			return
		}
	}, [])

	useEffect(() => {
		ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
			if (value !== password) {
				return false
			}
			return true
		})
		return () => {
			ValidatorForm.removeValidationRule('isPasswordMatch')
		}
	}, [password])

	const handleShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword })
	}

	const handleShowPassword2 = () => {
		setValues({ ...values, showPassword2: !values.showPassword2 })
	}

	return (
		<main className={classes.main} style={{ backgroundImage: `url(${localStorage.getItem('background')})` }}>
			<div className={classes.content}>
				<Paper className={classes.paper}>
					<Avatar className={classes.avatar}>
						<LockOutlinedIcon />
					</Avatar>
					<Typography component="h1" variant="h5">
						{t('registeraccount.label')}
					</Typography>
					<ValidatorForm
						onSubmit={onRegister}
					>
						<TextValidator
							margin="normal"
							fullWidth
							label={t('name.label')}
							onChange={e => setName(e.target.value)}
							autoComplete="off"
							autoFocus
							validators={['required']}
							errorMessages={[t('fieldrequired.label')]}
							value={name}
							inputProps={{
								id: 'name',
								name: 'name',
							}}
						/>
						<InputLabel htmlFor="name" style={{ fontSize: 0 }}>{t('name.label')}</InputLabel>
						<TextValidator
							margin="normal"
							fullWidth
							label={t('emailadress.label')}
							onChange={e => setEmail(e.target.value)}
							autoComplete="off"
							inputProps={{
								id: 'email',
								name: 'email',
								style: {
									textTransform: 'lowercase'
								}
							}}
							validators={['required', 'isEmail']}
							errorMessages={[t('fieldrequired.label'), t('emailnotvalid.label')]}
							value={email}
						/>
						<InputLabel htmlFor="email" style={{ fontSize: 0 }}>{t('emailadress.label')}</InputLabel>
						<TextValidator
							margin="normal"
							fullWidth
							label={t('password.label')}
							onChange={e => setPassword(e.target.value)}
							type={values.showPassword ? 'text' : 'password'}
							validators={['required']}
							errorMessages={[t('fieldrequired.label')]}
							value={password}
							InputProps={{
								id: 'password',
								name: 'password',
								endAdornment: (
									<InputAdornment position="end">
										<IconButton aria-label="Toggle password visibility" onClick={handleShowPassword}>
											{values.showPassword ? <Visibility /> : <VisibilityOff />}
										</IconButton>
									</InputAdornment>
								)
							}}
						/>
						<InputLabel htmlFor="password" style={{ fontSize: 0 }}>{t('password.label')}</InputLabel>
						<TextValidator
							margin="normal"
							fullWidth
							label={t('confirmpassword.label')}
							onChange={e => setRepeatpassword(e.target.value)}
							type={values.showPassword2 ? 'text' : 'password'}
							validators={['isPasswordMatch', 'required']}
							errorMessages={[t('passwordmismatch.label'), t('fieldrequired.label')]}
							value={repeatpassword}
							InputProps={{
								id: 'repeatpassword',
								name: 'repeatpassword',
								endAdornment: (
									<InputAdornment position="end">
										<IconButton aria-label="Toggle password visibility" onClick={handleShowPassword2}>
											{values.showPassword2 ? <Visibility /> : <VisibilityOff />}
										</IconButton>
									</InputAdornment>
								)
							}}
						/>
						<InputLabel htmlFor="repeatpassword" style={{ fontSize: 0 }}>{t('confirmpassword.label')}</InputLabel>
						<Button
							type="submit"
							fullWidth
							variant="contained"
							color="primary"
							className={classes.submit}>
							{t('register.label')}
						</Button>
					</ValidatorForm>
					<Button
						fullWidth
						variant="contained"
						color="secondary"
						component={Link}
						to="/"
						className={classes.submit}>
						{t('backhomepage.label')}
					</Button>

				</Paper>
			</div>
		</main>
	)

	async function wait(ms) {
		return new Promise(resolve => {
			setTimeout(resolve, ms);
		});
	}

	async function onRegister() {
		try {
			await firebase.register(name, email, password)
			await firebase.doSendEmailVerification()
			await toast.success(`${t('registerprogress.label')}`)
			await wait(1200)
			props.history.push('/dashboard')
		} catch (error) {
			alert(error.message)
		}
	}
}

export default withRouter(withStyles(styles)(Register))